/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Project_Rag_Override_Set_DescInputs */



/**
* | output |
* | --- |
* | "The internal-only override for project \"{name}\" was updated." |
*
* @param {Audit_Details_Project_Rag_Override_Set_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_project_rag_override_set_desc = /** @type {((inputs: Audit_Details_Project_Rag_Override_Set_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Project_Rag_Override_Set_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Nur-interne-Quellen-Override für das Projekt "${i?.name}" wurde aktualisiert.`)
	return /** @type {LocalizedString} */ (`The internal-only override for project "${i?.name}" was updated.`)
});